<div class="card sidebar">
  <mat-card class="sub-competency-sidebar">
  <div class="title">Sub Competencies </div>
  <div>
    <ul>
      <li *ngFor="let tab of tabs" [class.active]="selectedTabName === tab.name" 
      (click)="selectTab(tab)">{{ tab.name }}
      </li>
    </ul>
  </div>
</mat-card>
</div>

